__turbopack_context__.v({
  "className": "open_sans_6e3d5a8-module__b1diIG__className",
});
